var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{staticClass:"dark_bg",attrs:{"title":"我的包裹","left-arrow":"","fixed":"","z-index":101},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"logistics-list"},[_c('waybillList',{staticClass:"list"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }